import { Component, Fragment } from 'react';
import { CDN_CLRSAVE_URL } from '../../constants';
import styles from '../../styles/search.scss';
import cx from 'classnames';

interface Props {
  filters: FilterItem[];
  filterName: string;
  onCheckboxClick: any;
  category: string;
  activeFilters?: string[];
  filterCategoryValueMap: any;
  showSubFilter: boolean; // set true if want to show subcategories
}

interface FilterItem {
  label: string;
  key: string;
  subCategory?: any[];
  isSelected: boolean;
}

interface State {
  collapseFilter: boolean;
  filterCategoryValueMap: any;
  category: string;
}

class FilterGroupNew extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const { filterCategoryValueMap, category } = this.props;
    this.state = {
      collapseFilter: false,
      filterCategoryValueMap,
      category,
    };
  }

  public handlecollapseFilter = () => {
    const { collapseFilter } = this.state;
    this.setState({
      collapseFilter: !collapseFilter,
    });
  };

  private getAllSubCategories(filter: FilterItem): any {
    const allSubs = filter.hasOwnProperty('categoryFilter.categoryFilterValue')
      ? filter['categoryFilter.categoryFilterValue']
      : null;
    return allSubs;
  }
  // Get all subcategories for filter
  private showSubCategories(filter: FilterItem) {
    const allSubs = this.getAllSubCategories(filter);
    const { category, filterCategoryValueMap, onCheckboxClick } = this.props;
    if (
      filterCategoryValueMap[category].indexOf(filter.key) !== -1 &&
      allSubs != null &&
      allSubs.length !== 0
    ) {
      return (
        <ul className={cx(styles['filter-item-parent-subCategory'])}>
          {allSubs.map((sc) => (
            <li
              className={cx(styles['filter-item'])}
              data-attr={sc.key}
              data-category="categoryFilter.categoryFilterValue"
              onClick={onCheckboxClick}
              key={sc.key}
            >
              <span
                className={cx(styles['filter-item-checkbox'], {
                  [styles['filter-item-checkbox-selected']]:
                    filterCategoryValueMap[
                      'categoryFilter.categoryFilterValue'
                    ].indexOf(sc.key) !== -1,
                })}
              >
                <img
                  src={`${CDN_CLRSAVE_URL}/ct-frontend/images/checkboxTick.png`}
                />
              </span>
              <span className={styles['filter-item-label']}>{sc.label}</span>
            </li>
          ))}
        </ul>
      );
    }
  }
  public render() {
    const {
      filters,
      onCheckboxClick,
      category,
      filterName,
      filterCategoryValueMap,
      showSubFilter,
    } = this.props;
    const { collapseFilter } = this.state;
    return (
      <div className={styles['filter-item-container']}>
        <div>
          <span
            className={`lil-flex lil-items-center lil-font-semibold lil-text-s-14 ${styles['filter-name']}`}
          >
            {filterName}
            {/* {filterName === 'Exit Load' &&  <img
                                className="lil-ml-2"
                                title = 'Mutual funds companies collect an amount from investors when they join or leave a scheme. This fee charged is generally referred to as a ‘load’. Exit load is a fee or an amount charged from an investor for exiting or leaving a scheme or the company as an investor.'
                                src="https://assets1.cleartax-cdn.com/cleartax/images/1628666864_group17971.svg"
                                alt="tooltip"
                              />
          } */}
          </span>
        </div>
        {!collapseFilter ? (
          <ul
            className={`${
              filterName === 'Category' ||
              filterName === 'Rating' ||
              filterName === 'Risk' ||
              filterName === 'Exit Load'
                ? 'lil-flex lil-flex-wrap lil-mt-2'
                : `${styles['filter-item-parent']} ${styles['mobile-overflow']}`
            }`}
          >
            {filters.map((filter: FilterItem) =>
              filterName === 'Category' ||
              filterName === 'Status' ||
              filterName === 'Rating' ||
              filterName === 'Risk' ||
              filterName === 'Exit Load' ? (
                <li
                  className={`lil-rounded-xxl lil-text-s-14 lil-border-sm lil-px-2 lil-my-2 lil-cursor-pointer lil-mr-2 lil-py-1 ${
                    (filterCategoryValueMap[category] || []).indexOf(
                      filter.key
                    ) !== -1
                      ? 'lil-text-blue-350 lil-border-blue-350'
                      : 'lil-border-grey-300 '
                  }`}
                  data-attr={filter.key}
                  data-category={category}
                  onClick={onCheckboxClick}
                  key={filter.key}
                >
                  {
                    <Fragment>
                      <span className={styles['filter-item-label']}>
                        {filter.label}
                      </span>
                    </Fragment>
                  }
                </li>
              ) : (
                <li
                  className={cx(styles['filter-item'])}
                  data-attr={filter.key}
                  data-category={category}
                  onClick={onCheckboxClick}
                  key={filter.key}
                >
                  {
                    <Fragment>
                      <span
                        className={cx(styles['filter-item-checkbox'], {
                          [styles['filter-item-checkbox-selected']]:
                            filterCategoryValueMap[category].indexOf(
                              filter.key
                            ) !== -1,
                        })}
                      >
                        <img
                          src={`${CDN_CLRSAVE_URL}/ct-frontend/images/checkboxTick.png`}
                        />
                      </span>
                      <span className={styles['filter-item-label']}>
                        {filter.label}
                      </span>
                      {/* Shows subcategories for the selected category filter */}
                      {showSubFilter && category === 'fundType'
                        ? this.showSubCategories(filter)
                        : null}
                    </Fragment>
                  }
                </li>
              )
            )}
          </ul>
        ) : null}
      </div>
    );
  }
}

export default FilterGroupNew;



// WEBPACK FOOTER //
// ./components/search/filterGroupNew.tsx